import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { SENTRY_DSN } from '../constants';
import { initialiseSentry } from './initialise-sentry';
export var sentryClient;
export var setSentryClient = function setSentryClient(client) {
  sentryClient = client;
};
export var getSentryClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (sentryClient) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return setupSentryClient({});
        case 3:
          return _context.abrupt("return", sentryClient);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSentryClient() {
    return _ref.apply(this, arguments);
  };
}();
export function setupSentryClient(_x) {
  return _setupSentryClient.apply(this, arguments);
}
function _setupSentryClient() {
  _setupSentryClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var _window$__buildInfo;
    var appName, env, sentryClient;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          appName = _ref2.appName, env = _ref2.env;
          _context2.next = 3;
          return requireSentryLib();
        case 3:
          sentryClient = _context2.sent;
          if (sentryClient) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          // initialiseSentry sets the sentry client
          initialiseSentry(sentryClient, {
            initialScope: {
              tags: {
                renderMode: appName || 'unknown',
                productBuild:
                // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || ((_window$__buildInfo = window.__buildInfo) === null || _window$__buildInfo === void 0 ? void 0 : _window$__buildInfo.FRONTEND_VERSION) || 'unknown',
                product: getProduct()
              }
            },
            env: env,
            noGlobals: true,
            dsn: SENTRY_DSN,
            attachStacktrace: true
          });
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _setupSentryClient.apply(this, arguments);
}
function requireSentryLib() {
  return _requireSentryLib.apply(this, arguments);
}
function _requireSentryLib() {
  _requireSentryLib = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          return _context3.abrupt("return", import( /* webpackChunkName: "teams-client_sentry" */'@sentry/browser'));
        case 4:
          _context3.prev = 4;
          _context3.t0 = _context3["catch"](0);
          // eslint-disable-next-line no-console
          console.warn('Ignoring rejected promise when loading sentry resource.', _context3.t0);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 4]]);
  }));
  return _requireSentryLib.apply(this, arguments);
}
function getProduct() {
  var path = window.location.pathname;
  if (path.includes('/jira/people')) {
    return 'jira';
  } else if (path.includes('/wiki/people')) {
    return 'confluence';
  }
  return 'unknown';
}